export default __webpack_public_path__ + "static/media/flameswap.7b1f9a5e.svg";